import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as asn1js from "asn1js";
import * as pkijs from "pkijs";
import { BryAuthService } from './bry-auth.service';

@Injectable({
  providedIn: 'root'
})
export class BryService {

  URL_FINALIZE_PDF_SERVER = 'https://hub2.bry.com.br/fw/v1/pdf/pkcs1/assinaturas/acoes/finalizar';

  constructor(private http: HttpClient, private readonly _authService: BryAuthService) { }

  async finalize(nonceRequisicao: string, hash: string): Promise<any> {
    const token = await this._authService.getToken();

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const body = {
      tipoRetorno: "LINK",
      nonce: nonceRequisicao,
      assinaturasPkcs1: [
        {
          cifrado: hash,
          nonce: "1"
        }
      ],
      formatoDeDados: "Base64"
    };

    return this.http
      .post<any>(this.URL_FINALIZE_PDF_SERVER, body, { headers })
      .toPromise()
      .catch(error => {
        console.error('Erro na requisição:', error);
        throw error;
      });
  }


  getSignature(link: string) {
    return this.http.get(link, { responseType: 'blob' });
  }


  async extrairAlgoritmoHash(base64Cert: string): Promise<string> {
    const binaryDerString = atob(base64Cert);
    const binaryDer = new Uint8Array([...binaryDerString].map(c => c.charCodeAt(0)));
    const asn1 = asn1js.fromBER(binaryDer.buffer);
    const cert = new pkijs.Certificate({ schema: asn1.result });

    const oid = cert.signatureAlgorithm.algorithmId;

    switch (oid) {
      case "1.2.840.113549.1.1.11": return "SHA256";
      case "1.2.840.113549.1.1.12": return "SHA384";
      case "1.2.840.113549.1.1.13": return "SHA512";
      default: return "SHA256";
    }
  }

}
